import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Logo, IconGrid, IconFlow, IconForecast, IconDesert, IconScale, IconLayers,
  IconUsers, IconAlert, IconCalendar, IconSliders, IconCube, IconRadar,
  IconLogout,
} from './icons';

const NAV = [
  { section: 'Pilotage', items: [
    { to: '/', label: "Vue d'ensemble", icon: IconGrid, end: true },
    { to: '/cartographie-od', label: 'Cartographie OD', icon: IconFlow },
    { to: '/previsions', label: 'Prévisions de flux', icon: IconForecast },
  ]},
  { section: 'Territoire', items: [
    { to: '/deserts', label: 'Déserts de mobilité', icon: IconDesert },
    { to: '/accessibilite', label: 'Indice d\'accessibilité', icon: IconScale },
    { to: '/profilage', label: 'Profilage des zones', icon: IconLayers },
  ]},
  { section: 'Temps réel', items: [
    { to: '/anomalies', label: 'Anomalies', icon: IconAlert },
    { to: '/evenements', label: 'Événements spéciaux', icon: IconCalendar },
  ]},
  { section: 'Décision', items: [
    { to: '/optimiseur', label: 'Optimiseur de lignes', icon: IconSliders },
    { to: '/jumeau-numerique', label: 'Jumeau numérique', icon: IconCube },
    { to: '/prevision-evenementielle', label: 'Prévision événementielle', icon: IconRadar },
  ]},
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const initials = (user?.full_name || user?.username || '?')
    .split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase();

  return (
    <aside className="sidebar">
      <div className="brand">
        <div className="brand__mark"><Logo /></div>
        <div>
          <div className="brand__name">SmartMobility</div>
          <div className="brand__tag">Dakar · D4D</div>
        </div>
      </div>

      <nav className="nav">
        {NAV.map((group) => (
          <React.Fragment key={group.section}>
            <div className="nav__label">{group.section}</div>
            {group.items.map(({ to, label, icon: Icon, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) => `nav__item${isActive ? ' is-active' : ''}`}
              >
                <Icon />
                <span>{label}</span>
              </NavLink>
            ))}
          </React.Fragment>
        ))}
      </nav>

      <div className="sidebar__footer">
        <div className="userbox">
          <div className="userbox__avatar">{initials}</div>
          <div className="userbox__id">
            <div className="userbox__name">{user?.full_name || user?.username || 'Administrateur'}</div>
            <div className="userbox__role">Administrateur</div>
          </div>
          <button className="userbox__logout" onClick={logout} title="Se déconnecter">
            <IconLogout width={17} height={17} />
          </button>
        </div>
      </div>
    </aside>
  );
}
